export const messages = {
  technicalError: "Kuna tatizo la kiufundi, jaribu tena",
};
